import React from "react";

const GetInTouch = () => {
  return (
    <>
      <div className="row get-in-touch">
        <span>What's Next?</span>
        <h2>Get In Touch</h2>
        <p>
          I’m always looking for new opportunities so my inbox is always open.
          Whether you have a question or just want to say hi, I’ll try my best
          to get back to you!
        </p>
        <div className="col-md-2"></div>
        <div className="col-md-2"></div>
        <div className="col-md-4">
          <a
            className="email-link"
            title="mailto:quan.le1926@gmail.com"
            href="mailto:quan.le1926@gmail.com"
            rel="noopener noreferrer"
            target="_blank"
          >
            Say Hello
          </a>
        </div>
        <div className="col-md-2"></div>
        <div className="col-md-2"></div>
      </div>
      <div className="spacer" data-height="100"></div>
      <div className="spacer" data-height="100"></div>
    </>
  );
};

export default GetInTouch;
